import { Contact } from './contact'
import { User } from './user'
import { Address } from './address'
import { RiskControlScheme } from './risk-control'
import { EPaymentBrand, EStoreStatus } from './enum'
import { Currency, IQueryParams, IPagination, UpdateReq } from './common'
import { EChannelsSwitcherCategory } from './channels-switcher.interface'

export interface IStoreQueryParams extends IQueryParams {
  /*
    åå»ºæ¶é´
    é¨åºç¼å·
    é¨åºåç§°
    å½å®¶/å°åº
    é¨åºäº¤æå¸ç§
    å¼éæ¸ é
    æºæç¼å·
    æºæåç§°
    éå¢ç¼å·
    éå¢åç§°
    åæ·ç¼å·
    åæ·åç§°
  */
  startTime?: string
  endTime?: string
  storeNum?: string
  storeName?: string

  /** ç¨äºå¯¼åºæ¥è¡¨ */
  intStoreCode?: string
}

export interface IStoreDetailQueryParams {
  intStoreCode: string
}

export class StoreRiskControl {
  schemeCode: string
}

export class StoreCommon {
  /* new */
  insCode: string // æºæç¼å·
  insName: string // æºæåç§°
  insNameEN: string // æºæè±æåç§°
  agentCode: string // ä»£çç¼å·
  agentName: string // ä»£çåç§°
  agentNameEN: string // ä»£çè±æåç§°
  intMerCode: string // åé¨åæ·å·
  merNum: string // åæ·ç¼å·
  merName: string // åæ·åç§°
  merNameEN: string // åæ·è±æåç§°
  intStoreCode: string // åé¨é¨åºå·
  storeNum: string // é¨åºç¼å·
  storeName: string // é¨åºåç§°
  storeNameEN: string // é¨åºè±æåç§°
  multiTransCurrConfig: string[] // é¨åºäº¤æå¸ç§æ°ç»ï¼å¤å¸ç§éæ±
  remark?: string // å¤æ³¨ä¿¡æ¯
  permission: string[] // æ¥å£æé
  paymentBrands: EPaymentBrand[] // æ¯ä»åç
  contact: Contact // èç³»ä¿¡æ¯
  address: Address // å°åä¿¡æ¯
  mcc: string
  mccEnName?: string
  status: EStoreStatus // é¨åºç¶æï¼å¯¹åºæå¡ç«¯å­æ®µä¸º merStatus

  /* old */
  detail: StoreDetail
  options: IStoreOptions
  alpRefundAsync: boolean // trueè¡¨ç¤ºå¼æ­¥éæ¬¾ï¼false è¡¨ç¤ºåæ­¥éæ¬¾
  isCollectQRCodeAmountFixed: boolean // æ¯å¦æ¯æåºå®éé¢æ¶æ¬¾ç 
  drivers?: IDriver[]
  isSupportTips: boolean // æ¯å¦æ¯æå°è´¹
  tipsRatios: number[] // å°è´¹æ¯ç

  createdAt: string
  updatedAt: string
  currencies: Currency[]

  settlement: Settlement
  riskControl: RiskControlScheme

  constructor() {
    this.settlement = new Settlement()
    this.riskControl = new RiskControlScheme()
    this.contact = new Contact()
    this.address = new Address()
  }
}

// é¨åºä¸äºè¯¦æçæ¥å£
export class StoreDetail {
  storeName: string // é¨åºï¼è±æï¼åç§°
  storeNameLocal: string // é¨åºæ¬å°åç§°
  nation: string
  province: string
  city: string
  addr: string
  commodityName: string
  mcc: string
  contact: string
  email: string

  constructor() {}
}

// ä¸äºéè¦éå¾æ¸ éçæ¥å£
export interface IStoreOptions {
  merchant_name?: string
  merchant_no?: string
  store_no?: string
  business_no?: string
  terminal_id?: string
  mcc?: string
  region_code?: string
}

// é¨åºä¸­å¸æºä¿¡æ¯
export interface IDriver {
  driverName: string // åç§°
  driverContact: string // èç³»çµè¯
  driverAccount: string // ç¼å·
}

// æ¸ éäº¤æä¿¡æ¯
// export class TransChannel {
//   public intStoreCode: string // åé¨é¨åºå·
//   public chanCode: string // æ¸ éä»£ç 
//   public cardBrand: string // å¡åç
//   public mcc: string // äº¤æMCC
//   public currency: string // äº¤æå¸ç§
//   public fee: number // äº¤æè´¹ç
//   public chanMerID: string // å¤§åæ·å·
//   public chanMerName: string // å¤§åæ·åç§°
//   public secondaryChanMerID: string // å­åæ·å·
//   public secondaryChanMerName: string // å­åæ·åç§°
// }

// æ¸ç®ä¿¡æ¯
export class Settlement {
  public bank: string // å¼æ·é¶è¡
  public bankCodeSWIFT: string // å¼æ·é¶è¡SWIFTä»£ç 
  public bankAccount: string // é¶è¡è´¦å·
  public bankAccountName: string // é¶è¡è´¦å·å
  public isSupportDualMessage = false // æ¯å¦æ¯æåä¿¡æ¯
  public settleType: ESettleType = ESettleType.T1 // æ¸ç®ç±»åï¼1: T+1, 2: å»¶è¿æ¸ç®, 3: ç´¯è®¡æ¸ç®
  public settleCycleDays = 1 // å»¶è¿/ç´¯è®¡å¤©æ°
}

export enum ESettleType {
  T1 = '1',
  Delay = '3',
  AddUp = '4',
}

export const SettleTypeMap = {
  1: 'BIZ.STORE.OTHER.SETTLEMENT.TYPE.T1',
  3: 'BIZ.STORE.OTHER.SETTLEMENT.TYPE.DELAY',
  4: 'BIZ.STORE.OTHER.SETTLEMENT.TYPE.ADDUP',
}

export interface ISettlementQueryParams {
  bank: string
}

export interface IStorePagination extends IPagination {
  data: Store[]
}

export interface IRouteOfStore {
  id?: string
  chanCode: EPaymentBrand // æ¸ éä»£ç 
  paymentBrand: EPaymentBrand // æ¯ä»åç
  chanMerName?: string
  mcc?: string // äº¤æMCC
  fee?: number // åæ·è´¹ç
  currency?: string // æ¸ éäº¤æå¸ç§
  chanMerObjId?: string
  sponsorMerCode?: string
}

// æ°çé¨åºè·¯ç±ä¸æ¸ éä¿¡æ¯ä¿å­æ¥å£
export interface IQRRouteOfStore extends IRouteOfStore {
  category?: EChannelsSwitcherCategory.QR
  isCreateSubMer?: boolean // æ¯å¦èªå¨å¥ç½
  chanMerParams?: IStoreChanMer
}

export interface ICardRouteOfStore extends IRouteOfStore {
  category?: EChannelsSwitcherCategory.Card
  offlineChannelInsCode?: string
  offlineInsCode?: string
  chanMerParams?: IStoreCardChanMer
  ain?: string
  first3DigitsOfSENumber?: string
  chanNameEN?: string
  chanAddrEN?: string
  accessMode?: string
  mna?: string
  sponsorMerCode?: string
  mccNameEN?: string
}

export interface IStoreCardChanMer {
  offlineInsCode?: string
  id?: string
  bin?: string
  ica?: string
  ain?: string
  first3DigitsOfSENumber?: string
}

export interface IStoreCardChanMerMCC extends IStoreCardChanMer {
  ica: string
  first3DigitsOfSENumber?: string
}

export interface IStoreCardChanMerAME extends IStoreCardChanMer {
  ain: string
}

export interface IStoreChanMer {
  paymentBrand?: EPaymentBrand // æ¯ä»åç
}

export interface IStoreChanMerAlipay extends IStoreChanMer {
  PID: string
  secondaryMerchantID: string
  secondaryMerchantName: string
  storeID: string
  storeName: string
}

export interface IStoreChanMerWeChat extends IStoreChanMer {
  merchantID: string
  subMerchantID: string
}

export interface IStoreChanMerUPI extends IStoreChanMer {
  acquiringIIN: string
  forwardingIIN: string
}

export interface IStoreChannelInAPP {
  appID: string
  signKey?: string
}

export interface IStoreChannelMiniProgram {
  appID: string
  signKey?: string
}

export class StoreQRFeature {
  isRefundAsync = false
  isSupportTips = false
}

export class StoreCardFeature {
  isRefundAsync = false
  tradeTypes: string[] = []
}

// Store represents a store entity
export class Store {
  common: StoreCommon
  qr: StoreQRFeature
  card: StoreCardFeature
  version: number
  createdAt: string
  updatedAt: string

  constructor() {
    this.common = new StoreCommon()
    this.qr = new StoreQRFeature()
    this.card = new StoreCardFeature()
  }
}

/**
 * find è¿å
 */
export class StoreFull {
  store: Store
  qrChannels: IQRRouteOfStore[] = []
  cardChannels: ICardRouteOfStore[] = []
  riskScheme: RiskControlScheme // äºä¸­é£æ§æ¹æ¡
  postRiskScheme: RiskControlScheme // äºåé£æ§æ¹æ¡
}

export class StoreCommonReq {
  /* åå»ºè¿ç¨ä¸­æå­çæ°æ®ï¼å¨åéæ¶éè¦ç¨å°ï¼ä½ä¸éè¦åéå°åç«¯ */
  insCode: string // æºæå·
  insName: string // æºæåç§°
  insNameEN: string // æºæè±æåç§°
  agentCode: string // éå¢å·
  agentName: string // éå¢åç§°
  agentNameEN: string // éå¢è±æåç§°
  intMerCode: string
  merNum: string
  merName: string
  merNameEN: string
  zipCode: string
  storeNum: string
  storeName: string
  storeNameEN: string
  mcc: string
  settlement: Settlement
  contact: Contact
  address: Address // äºæ
  currencies: Currency[] = []
  riskControl: StoreRiskControl

  constructor() {
    this.contact = new Contact()
    this.address = new Address()
    this.settlement = new Settlement()
    this.riskControl = new StoreRiskControl()
  }
}

export class StoreReq {
  common: StoreCommonReq
  qr: StoreQRFeature
  card: StoreCardFeature

  constructor() {
    this.common = new StoreCommonReq()
    this.qr = new StoreQRFeature()
    this.card = new StoreCardFeature()
  }
}

/**
 * æ°å¢
 */
export class StoreCreate {
  store: StoreReq
  qrChannels: IQRRouteOfStore[] = []
  cardChannels: ICardRouteOfStore[] = []
  users: User[] = []
  riskSchemeCode: string // äºä¸­é£æ§ä»£ç 
  postRiskSchemeCode: string // äºåé£æ§ä»£ç 
  select: {
    schemeCode: string
    schemeName: string
    schemeDesc: string
  }
  constructor() {
    this.store = new StoreReq()
  }
}

export class StoreCommonUpdate {
  storeName: string // é¨åºåç§°
  storeNameEN: string // é¨åºè±æåç§°
  mcc: string
  currencies: Currency[] // äº¤æå¸ç§
  contact: Contact // èç³»ä¿¡æ¯
  address: Address // å°åä¿¡æ¯
  status: EStoreStatus // é¨åºç¶æï¼å¯¹åºæå¡ç«¯å­æ®µä¸º merStatus

  constructor() {
    this.contact = new Contact()
    this.address = new Address()
  }
}

// StoreUpdate represent a request body for updating base info of a store
export class StoreUpdate extends UpdateReq {
  common: StoreCommonUpdate

  constructor(version: number) {
    super()
    this.version = version
    this.common = new StoreCommonUpdate()
  }
}

export class StoreSettlementUpdate extends UpdateReq {
  settlement: Settlement

  constructor(version: number) {
    super()
    this.version = version
    this.settlement = new Settlement()
  }
}

export class StoreRiskControlUpdate extends UpdateReq {
  riskSchemeCode: string
  postRiskSchemeCode: string

  constructor(version: number) {
    super()
    this.version = version
  }
}

export class StoreCardFeatureUpdate extends UpdateReq {
  feature: StoreCardFeature

  constructor() {
    super()
    this.feature = new StoreCardFeature()
  }
}

export class StoreQRFeatureUpdate extends UpdateReq {
  feature: StoreQRFeature

  constructor(version: number) {
    super()
    this.version = version
    this.feature = new StoreQRFeature()
  }
}

export interface IStoreReportPagination {
  url: string
}

export const enum EOtherDetailTab {
  Terminal = 'terminal',
  QrChannel = 'qrChannel',
  CardChannel = 'cardChannel',
  System = 'system',
  Settlement = 'settlement',
  QrFunction = 'qrFunction',
  CardFunction = 'cardFunction',
  RiskControl = 'riskControl',
  Users = 'users',
  Rules= 'rules',
  Range= 'range'
}

// AMEX æ¸ é

export class MetaData {
  chanNameEN?: string
  chanAddrEN?: string
}
